import {TscStyles} from '@techsmith/tsc-cloud-style-guide';
import cssConstants from './cssConstants';

type SmartPlayerEnvironment = 0 | 1 | 2 | 3 | 4;

interface SmartPlayerConstants {
   environments: {
      [environmentName: string]: SmartPlayerEnvironment;
   };
   contentType: {
      unknown: string;
      audio: string;
      image: string;
      video: string;
      youtube: string;
   };
   analytics: {
      viewEvent: string;
      viewAction: {
         FromLti: string;
         FromEmbed: string;
         FromViewPage: string;
         FromUnknown: string;
      };
   };
   imageBackgroundColorDawn: string;
   imageBackgroundColorDusk: string;
   videoBackgroundColor: string;
   minPlayerHeight: string;
   youtubeControls: string;
}

export default {
   environments: {
      local: 1,
      dev: 1,
      stage: 2,
      live: 3,
      test: 4
   },
   contentType: {
      unknown: 'unknown',
      audio: 'audio',
      image: 'image',
      video: 'video',
      youtube: 'youtube'
   },
   analytics: {
      viewEvent: 'view',
      viewAction: {
         FromLti: 'Viewed On LTI Page',
         FromEmbed: 'Viewed On Embed Page',
         FromViewPage: 'Viewed On The View Page',
         FromUnknown: 'Viewed From Unknown Source'
      }
   },
   imageBackgroundColorDawn: cssConstants.dawnPageBackgroundColor,
   imageBackgroundColorDusk: TscStyles.color.ui.dusk.dark,
   videoBackgroundColor: '#000',
   // this is roughly the height of the quizzing email required input form, seems a reasonable cut-off, else this dialog is unusable
   minPlayerHeight: '360px',
   youtubeControls: 'youtube'
} as SmartPlayerConstants;
